import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import { ImCross } from "react-icons/im";
const LeadFormModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [delay, setDelay] = useState(0); // initial delay in ms
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Check if already submitted
    if (localStorage.getItem("leadFormSubmitted")) return;

    const timer = setTimeout(() => setShowModal(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const handleClose = () => {
    setShowModal(false);
    setDelay((prev) => prev + 120000); // increase delay
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      handleClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      localStorage.setItem("leadFormSubmitted", "true");
      navigate(
        "/lp/full-stack-webdevelopment-and-digital-marketing/thank-you",
        { state: { formData } }
      );
    } catch (error) {
      console.error("EmailJS Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
     {showModal && (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fixed inset-0 flex items-center justify-center z-50 p-4"
  >
    {/* Backdrop with subtle blur effect */}
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm"
      onClick={handleBackdropClick}
    />

    {/* Modal Container */}
    <motion.div
      initial={{ scale: 0.95, y: 20 }}
      animate={{ scale: 1, y: 0 }}
      exit={{ scale: 0.95, y: 20 }}
      transition={{ type: "spring", damping: 25, stiffness: 300 }}
      className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-xl shadow-2xl w-full max-w-md border border-gray-200"
    >
      {/* Close Button */}
      <button
        onClick={handleClose}
        className="absolute top-5 right-5 p-1.5 rounded-full  hover:bg-gray-300 transition-colors text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
        aria-label="Close modal"
      >
        <ImCross/>
      </button>

      {/* Header */}
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900 tracking-tight">
          Get a Quote
        </h2>
        <p className="mt-2 text-gray-600">
          Fill in your details and we'll get back to you within 24 hours.
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-gray-900 placeholder-gray-400"
            required
          />
        </div>

        <div>
          <input
            type="tel"
            id="number"
            name="number"
            placeholder="Mobile Number"
            value={formData.number}
            onChange={(e) => setFormData({ ...formData, number: e.target.value })}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-gray-900 placeholder-gray-400"
            required
          />
        </div>

        <div>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Your email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-gray-900 placeholder-gray-400"
            required
          />
        </div>

        <div>
          <textarea
            id="message"
            name="message"
            placeholder="Tell us about your project..."
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            rows={3}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-gray-900 placeholder-gray-400"
            
          />
        </div>

        <button
          type="submit"
          className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium rounded-lg hover:from-blue-700 hover:to-blue-600 transition-all shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Submit Request
        </button>
      </form>

      {/* Footer Note */}
      <p className="mt-4 text-xs text-gray-500 text-center">
        We respect your privacy. Your information will never be shared.
      </p>
    </motion.div>
  </motion.div>
)}
    </>
  );
};

export default LeadFormModal;
